<template>
  <div id="payment">
    <div class="head" style="height: 52px;background-color:#fff;margin-bottom: 60px;"></div>
    <div class="content" v-if="order.orderStatus === 'WAIT_PAY'">
      <div class="top">
        <img src="../../assets/image/submit.png" alt="">
        <div class="top_right">
          <p class="wait">订单已提交，等待付款</p>
          <p class="hour">48小时内未付款将自动取消订单</p>
        </div>
      </div>
      <div class="pay-way">
        <p>支付方式</p>
        <p class="pay"><i class="el-icon-success"></i> 微信支付</p>
      </div>
      <div class="ma">
        <div id="qrcode">
          <vue-qr :text="config.value" :size="140" :margin="0"></vue-qr>
        </div>
        <div class="text">
          <p>打开手机微信</p>
          <p>扫一扫继续付款</p>
        </div>
      </div>
      <div class="money">
        <p class="text">应付：<span class="rmb">￥<span class="number">{{orderPrice | shareNowPrice}}</span></span></p>
      </div>
    </div>
    <div class="content1" v-else>
      <div class="top">
        <img src="../../assets/image/success.png" alt="">
        <div class="top_right">
          <p class="wait">支付成功</p>
          <p class="hour">商品正在打包，将尽快送达</p>
        </div>
      </div>
      <div class="details">
        <div class="row">
          <span class="w70">配送信息</span>
          <span class="ml6 w200">{{order.receiveName}}&nbsp;&nbsp;&nbsp;&nbsp;{{order.receivePhone}}</span>
          <span class="ml6">{{order.province}}{{order.city}}{{order.area}}{{order.address}}</span>
        </div>
        <div class="row">
          <span class="w70">订单号</span>
          <span class="ml6 w200">{{order.orderId}}</span>
        </div>
        <div class="row">
          <span class="w70">支付金额</span>
          <span class="ml6 w200">￥{{orderPrice | shareNowPrice}}</span>
        </div>
      </div>
      <div class="btn">
        <router-link to="/shoppingCar/orderList">
          <p class="look">查看订单</p>
        </router-link>
        <router-link to="/">
          <p class="back">回首页</p>
        </router-link>
      </div>
    </div>
    <!--<div class="ask" v-if="show">-->
      <!--<div class="word">-->
        <!--<div class="tet">确定离开此页面吗</div>-->
        <!--<div class="flex">-->
          <!--<p class="cancel" @click="isGoon(1)">取消</p>-->
          <!--<p class="ensure" @click="isGoon(2)">确定</p>-->
        <!--</div>-->
      <!--</div>-->
    <!--</div>-->
    <div class="footer" style="height: 60px;"></div>
  </div>
</template>

<script>
import VueQr from 'vue-qr'
import {WEBSOCKETLOC} from '../../common/js/vm.js'
let ws
export default {
  name: 'payment',
  inject: ['reload'],
  data () {
    return {
      msg: '二维码',
      config: {
        value: 'weixin://wxpay/bizpayurl?pr=1JZyCtV',
        imagePath: require('../../assets/icon/logo_w.png'),
        fillType: 'fill',
        version: 35,
        filter: 'threshold'
      },
      orderId: '',
      order: [],
      orderPrice: '',
      page: 0,
      show: false,
      goon: false
    }
  },
  beforeRouteLeave (to, from, next) {
    this.show = true
    // this.open()
    // if (this.goon) {
    //   next()
    // }
    next(confirm('是否离开当前界面?'))
  },
  mounted: function (s) {
    let par = this.$route.params
    if (par.orderId) {
      this.orderId = par.orderId
      this.config.value = par.codeUrl
      localStorage.setItem('payment_orderId', par.orderId)
      localStorage.setItem('payment_codeUrl', par.codeUrl)
    } else {
      this.orderId = localStorage.getItem('payment_orderId')
      this.config.value = localStorage.getItem('payment_codeUrl')
    }
    if (this.orderId) {
      this.orderDetails()
    } else {
      this.$store.commit('setToastMsg', '请选择订单')
    }
  },
  methods: {
    isLeave () {
      if (this.goon) {
        return true
      } else {
        return false
      }
    },
    isGoon (num) {
      if (num === 1) {
        this.goon = false
      } else if (num === 2) {
        this.goon = true
      }
      this.show = false
    },
    // open () {
    //   let that = this
    //   that.$confirm('您的订单还未付款, 确定离开吗?', '提示', {
    //     confirmButtonText: '确定',
    //     cancelButtonText: '取消',
    //     type: 'warning'
    //   }).then(() => {
    //     that.$message({
    //       type: 'success',
    //       message: '删除成功!'
    //     })
    //   }).catch(() => {
    //     that.$message({
    //       type: 'info',
    //       message: '已取消'
    //     })
    //   })
    // },
    'startWebSocket': function (OrderId) {
      if (!OrderId) {
        return
      }
      const that = this
      if (!window.WebSocket) {
        this.$store.commit('setToastMsg', '为保证正常服务，建议在新版浏览器中打开!')
        return
      }
      let websocketLoc = WEBSOCKETLOC
      console.log('开启通知' + websocketLoc)
      // create WebSocket
      ws = new WebSocket(websocketLoc)
      ws.onopen = function () {
        ws.send("{'orderId' : " + OrderId + ",'type' : 'BBS_ORDER'}")
      }
      ws.onmessage = function (res) {
        let result = JSON.parse(res.data)
        if (result.orderStatus === 'FINISH') {
          that.order.orderStatus = result.orderStatus
        }
      }
    },
    orderDetails () {
      let that = this
      that.axios.post('order/detail', {
        orderId: that.orderId
      }, {
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        },
        emulateJSON: true// 需要转json
      }).then(function (response) {
        if (response.data.status === 0) {
          console.log(response.data.value)
          that.order = response.data.value
          that.orderPrice = response.data.value.orderPrice
          that.$store.commit('setToastMsg', response.data.msg)
          if (that.order.orderStatus === 'WAIT_PAY') {
            that.startWebSocket(that.orderId)
          }
        } else {
          that.$store.commit('setToastMsg', response.data.msg)
        }
      }).catch(function (response) {
        that.$store.commit('setToastMsg', '网络错误')
      })
    }
  },
  components: {
    VueQr
  }
}
</script>

<style scoped>
  #payment{
    background-color: #f0f0f0;
    box-sizing: border-box;
  }
  .content{
    width: 1201px;
    height: 738px;
    margin: 0 auto;
    padding: 60px 40px 60px 40px;
    box-sizing: border-box;
    background-color: #fff;
  }
  .top{
    justify-content: center;
    display: flex;
    align-items: center;
    text-align: left;
  }
  .top>img{
    width: 107px;
  }
  .top_right{
    margin-left: 20px;
    color: #333;
  }
  .top_right .wait{
    font-size: 24px;
    font-family: "Source Han Sans CN Medium";
    color: #333;
  }
  .top_right .hour{
    font-size: 16px;
    margin-top: 10px;
    font-family: "SourceHanSansCN-Normal";
    color: #333;
  }
  /*----------------支付方式---------*/
  .pay-way{
    padding: 50px 0;
    border-bottom: 1px solid #ddd;
    text-align: left;
  }
  .pay-way>p{
    display: inline-block;
    font-size: 18px;
    font-family: "Source Han Sans CN Medium";
    color: #333;
  }
  .pay-way .pay{
    width: 226px;
    height: 44px;
    line-height: 44px;
    text-align: center;
    border: 1px solid #05b570;
    border-radius: 3px;
    margin-left: 20px;
    font-size: 16px;
    font-family: "SourceHanSansCN-Normal"
  }
  .el-icon-success{
    color:  #05b570;
  }
  /*-------------二维码样式------------*/
  .ma{
    margin-top:60px;
  }
  .ma .text{
    margin-top: 20px;
    line-height: 20px;
  }
  .ma .text>p{
    font-size: 16px;
    color: #333;
    font-family: "Source Han Sans CN Normal";
  }
  /*-------------应付款样式------------*/
  .money{
    margin-top: 54px;
    text-align: right;
    color: #292b31;
    border-top: 1px solid #cccccc;
  }
  .money .text{
    margin-top: 45px;
    font-family: "SourceHanSansCN-Normal";
  }
  .money .rmb{
    font-size: 23px;
    margin-left: 20px;
    font-family: "SourceHanSansCN-Normal";
  }
  .money .number{
    font-size: 30px;
    font-family: "SourceHanSansCN-Normal";
  }
  /*-------------支付成功后的样式------------*/
  .content1{
    width: 1201px;
    height: 624px;
    margin: 0 auto;
    padding: 80px 40px 60px 40px;
    box-sizing: border-box;
    background-color: #fff;
  }
  .details{
    margin-top: 60px;
    padding: 20px 20px 50px 20px;
    text-align: left;
    border-top: 1px solid #ddd;
    font-size: 16px;
    color: #333;
    box-sizing: border-box;
  }
  .details .row{
    margin-top: 30px;
  }
  .details .row>span{
    font-family: "SourceHanSansCN-Normal";
  }
  .ml6{
    margin-left: 60px;
  }
  .w70{
    display: inline-block;
    width: 70px;
  }
  .w200{
    display: inline-block;
    width: 200px;
  }
  .btn{
    margin-top: 57px;
  }
  .btn p{
    width: 197px;
    height: 44px;
    display: inline-block;
    line-height: 44px;
    text-align: center;
    border-radius: 3px;
    font-size: 16px;
  }
  .btn .look{
    color: #000;
    margin-right: 5px;
    background-color: #f4f4f4;
  }
  .btn .back{
    color: #FFFFFF;
    margin-left: 5px;
    background-color: #7e7d7d;
  }
  /*离开页面提示*/
  .ask{
    width: 100%;
    height: 100%;
    position: fixed;
    top: 0;
    left: 0;
    background-color: rgba(0,0,0,0.3);
    text-align: center;
    z-index: 999;
  }
  .ask .word{
    width: 600px;
    height: 200px;
    padding: 30px;
    margin: 100px auto;
    box-sizing: border-box;
    background-color: #fff;
  }
  .ask .cancel,
  .ask .ensure{
    width: 100px;
    height: 40px;
    line-height: 40px;
    color: #000;
    cursor: pointer;
    border: 1px solid #ccc;
  }
  .ask .ensure{
    background-color: #ddd;
  }
  .ask .flex{
    width: 260px;
    margin: 80px auto;
    display: flex;
    justify-content: space-between;
  }
</style>



// WEBPACK FOOTER //
// src/components/shoppingCar/payment.vue